import { render } from "./TrashList.vue?vue&type=template&id=32799808"
import script from "./TrashList.vue?vue&type=script&lang=js"
export * from "./TrashList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__